<template>
  <YouyanProvider
    :language="isChinese() ? 'zh-CN' : 'en-US'"
    :user-info="userInfo"
    :session="session"
    :api-base="getEnv('apiBase')"
    :messageCenterWs="getEnv('wsMessageCenter')"
    :messageCenterApi="getEnv('apiMessageCenter')"
    :assets-origin="getEnv('feOss')"
    :route="route"
    :router="router"
    :theme="currentTheme"
    :messageConfig="{
      upgrade: useUpgrade,
      addStorage: hasActionPermission('package_upgrade')
        ? useStorageSpace
        : undefined,
      addFeature: hasActionPermission('package_upgrade')
        ? useAddFeature
        : undefined,
    }"
    :area="area"
    @message-get="onMessageGet"
  >
    <NuxtLayout>
      <slot />
    </NuxtLayout>
  </YouyanProvider>
</template>

<script lang="ts" setup>
import { isChinese } from '@/utils/area'
import '@rendora/design/styles/atom.css'
import { YouyanProvider } from '@youyan/common'
import '@youyan/common/style.css'
import 'swiper/css'
import 'swiper/css/pagination'
import { BROADCAST_KEY } from '~/constants/config'
import { useStorageSpace } from '~/hooks/useStorageSpace'
import { getEnv } from '~/utils/env'
import { MESSAGE_TEMPLATE_ID, type Message } from './api/interface'
import { useFixedRightBottom } from './composables/fixedRightBottom'
import { useAddFeature } from './features/paymentDesk'
import { showFeedback } from './hooks/useModal/modals/feedback'
import { useUpdate } from './hooks/useUpdate'
import { useUpgrade } from './hooks/useUpgrade'

const area = getEnv('area') as 'CN' | 'US'
const currentTheme = useTheme()
const route = useRoute()
const router = useRouter()
const userInfo = useUserInfo()
const session = useSession()

const { hasActionPermission } = usePageAndActionPermissionData()

useUpdate()

const option = useFixedRightBottom()
option.value.onlineService = isChinese() && hasActionPermission('float_comps')

function onMessageGet(msg: Message) {
  // 这几个需要通知言币业务方
  if (
    [
      MESSAGE_TEMPLATE_ID.YANBIN_RETURN,
      MESSAGE_TEMPLATE_ID.CHENGPIAN_MERGE_CANCEL,
      MESSAGE_TEMPLATE_ID.COMPOSITION_RENDER_CANCEL,
      MESSAGE_TEMPLATE_ID.TRIAL_BENEFITS_RECEIVED,
    ].includes(msg.template_id)
  ) {
    emitter.emit(EVENT.YANBI_CHANGE)
  }

  // 需要更新用户信息
  if (
    [
      MESSAGE_TEMPLATE_ID.EQUITY_PURCHASE_SUCCESS,
      MESSAGE_TEMPLATE_ID.CHENGPIAN_MERGE_SUCCESS,
      MESSAGE_TEMPLATE_ID.USER_VERIFY_SUCCESS,
      MESSAGE_TEMPLATE_ID.USER_VERIFY_FAIL,
      MESSAGE_TEMPLATE_ID.USER_VERIFY_SUCCESS,
      MESSAGE_TEMPLATE_ID.ENTITY_EMPOWER_SUCCESS,
    ].includes(msg.template_id)
  ) {
    emitter.emit(EVENT.UPDATE_USER)
  }

  // 变更为管理账号
  if (
    [MESSAGE_TEMPLATE_ID.ACCEPT_TRANSFER_SUPER_ADMINISTRATOR_SUCCESS].includes(
      msg.template_id
    )
  ) {
    emitter.emit(EVENT.ADMIN_CHANGE)
  }
}

onMounted(() => {
  if (route.query.feedback) {
    showFeedback()
  }

  onBroadcast(BROADCAST_KEY.REFRESH, (data: any) => {
    const { tabId } = data
    if (tabId !== TAB_ID) {
      location.reload()
    }
  })
})
</script>

<style lang="scss" scoped>
.main-wrapper {
  &::before {
    display: block;
    content: '';
    width: 100%;
    height: calc($top-height - 1px);
    z-index: 999;
  }
}
</style>
